const RouteConstants = {
    Pages: {
        Error: "error",
        SSNPage: "dashboard",
    }
};

export default RouteConstants;
